/*
 * Module for the exception correction _DetailCompare partial view
*/

rs.module("content/employer/reporting/maintenance/detailcompare",

    [],

    function () {

        //
        // Initialize
        //
        function initialize(jsSelectors, backendUrls, accountPartyKey, lastPostedFlag) {

            // needs to be inside document.ready since the grid needs to be rendered before we can attach listeners to links inside it
            $(document).ready(function () {

                // Open the quick view popup for a member
                $.js(jsSelectors.memberQuickViewLink).click(function (e) {

                    // we don't want the row to be selected when clicking the quickview link
                    e.stopPropagation();

                    $.get(
                        backendUrls.getMemberQuickView,
                        {
                            lastPosted: lastPostedFlag,
                            accountPartyKey: accountPartyKey
                        }

                    ).done(function (result) {

                        $.js(jsSelectors.quickViewDetail).html(result);
                        $.js(jsSelectors.quickView).show();
                    });
                });

                // Open the quick view popup for a pay period
                $.js(jsSelectors.payPeriodQuickViewLink, { multiple: true }).click(function (e) {

                    // we don't want the row to be selected when clicking the quickview link
                    e.stopPropagation();

                    $.get(
                        backendUrls.getPayPeriodArchQuickView,
                        {
                            accountPartyKey: accountPartyKey,
                            detailPayPeriodKey: $(this).data("detailpayperiodkey"),
                            accountTransactionKey: $(this).data("accounttransactionkey")
                        }
                    ).done(function (result) {

                        $.js(jsSelectors.quickViewDetail).html(result);
                        $.js(jsSelectors.quickView).show();
                    });
                });
            });

            // Close the quick view popup
            $.js(jsSelectors.quickViewCloseLink).click(function () {
                $.js(jsSelectors.quickView).hide();
            });

        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);